var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Mixins } from "vue-property-decorator";
import { OrganisationRegistration } from "@/common/types/OrganisationRegistration";
import TextLabelRow from '@/common/components/TextLabelRow.vue';
import { Language } from "@/common/types/Language";
import { Focusable } from "@/common/mixins/Focusable";
var OrganisationConfirmation = /** @class */ (function (_super) {
    __extends(OrganisationConfirmation, _super);
    function OrganisationConfirmation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganisationConfirmation.prototype.mounted = function () {
        this.focusOnFirstTag("h2");
    };
    Object.defineProperty(OrganisationConfirmation.prototype, "fullName", {
        get: function () {
            return this.registration.registrarFirstName + ' ' + this.registration.registrarLastName;
        },
        enumerable: false,
        configurable: true
    });
    // TODO: Get language name from someplace nice
    OrganisationConfirmation.prototype.getLanguage = function (lang) {
        if (lang == Language.Swedish)
            return "Ruotsi";
        return "Suomi";
    };
    OrganisationConfirmation.prototype.done = function () {
        this.$router.push({ name: "login" });
    };
    Object.defineProperty(OrganisationConfirmation.prototype, "labelClass", {
        get: function () {
            return "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrganisationConfirmation.prototype, "valueClass", {
        get: function () {
            return "col-12 col-md-8 col-lg-9 pt-0 pt-md-2";
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof OrganisationRegistration !== "undefined" && OrganisationRegistration) === "function" ? _a : Object)
    ], OrganisationConfirmation.prototype, "registration", void 0);
    OrganisationConfirmation = __decorate([
        Component({
            name: "OrganisationConfirmation",
            components: {
                TextLabelRow: TextLabelRow
            }
        })
    ], OrganisationConfirmation);
    return OrganisationConfirmation;
}(Mixins(Focusable)));
export default OrganisationConfirmation;
